module.exports = __webpack_public_path__ + "static/benefit-ceremony-9f9898be684cddb79b61f59c4d75325e.png";